// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"616":"44ad4203","969":"95051010"}[chunkId] + ".chunk.js";
};